import { render, staticRenderFns } from "./AddCompany.vue?vue&type=template&id=36eb1e92&scoped=true"
import script from "./AddCompany.vue?vue&type=script&lang=js"
export * from "./AddCompany.vue?vue&type=script&lang=js"
import style0 from "./AddCompany.vue?vue&type=style&index=0&id=36eb1e92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eb1e92",
  null
  
)

export default component.exports